// extracted by mini-css-extract-plugin
export default {"closeButtonContainer":"PageCloseButton_closeButtonContainer__+BOt9","closeButton":"PageCloseButton_closeButton__oflsA"};